import { RoomState } from './index';
import { MutationTree } from 'vuex';
import AvailableRoom from "../interfaces/availableRoom";
import Room from "../interfaces/room";
import CheckoutItem from "../interfaces/checkoutItem";

const DEFAULT_DR_AMOUNT = 1;
const DEFAULT_SR_AMOUNT = 2;
const DOUBLE_ROOM = 'dr';
const SINGLE_ROOM = 'sr';
const DEFAULT_DR_PERSONS = 2;
const DEFAULT_SR_PERSONS = 1;

export default {
    initRooms(state) {
        const rooms: Room[] = [];

        state.availableRooms.forEach((room: AvailableRoom) => {
            rooms.push({
                id: room.id,
                roomType: room.roomType,
                minPersons: room.minPersons,
                maxPersons: room.maxPersons,
                amount: 0
            });
        });
        state.rooms = rooms;
    },
    initAvailableRooms(state, rooms: AvailableRoom[]) {
        rooms.forEach((room) => {
            if (room.roomType === DOUBLE_ROOM && room.minPersons === 0) {
                room.minPersons = DEFAULT_DR_PERSONS;
                room.maxPersons = DEFAULT_DR_PERSONS;
            }
            if (room.roomType === SINGLE_ROOM && room.minPersons === 0) {
                room.minPersons = DEFAULT_SR_PERSONS;
                room.maxPersons = DEFAULT_SR_PERSONS;
            }
        })
        state.availableRooms = rooms.filter((room) => room.minPersons > 0);

    },
    setInitialRooms(state) {
        const doubleRoom: Room | undefined = state.rooms.find((room: Room) => room.roomType === DOUBLE_ROOM);
        const singleRoom: Room | undefined = state.rooms.find((room: Room) => room.roomType === SINGLE_ROOM);
        if (doubleRoom !== undefined) {
            doubleRoom.amount = DEFAULT_DR_AMOUNT;
        } else if (singleRoom !== undefined) {
            singleRoom.amount = DEFAULT_SR_AMOUNT;
        }
    },
    resetRoomsAmount(state, checkoutItems: CheckoutItem[]) {
        state.rooms.forEach((room: Room) => {
            const roomItem: CheckoutItem | undefined = checkoutItems.find((ci: CheckoutItem) => ci.id === room.id);
            room.amount = 0;

            if (roomItem !== undefined) {
                room.amount = roomItem.amount;
            }
        })

        state.isRestored = true;
    },
    setRooms(state, checkoutItems: CheckoutItem[]) {
        checkoutItems.forEach((checkoutItem) => {
            const room: Room | undefined = state.rooms.find((r: Room) => r.id === checkoutItem.id);
            if (room !== undefined) {
                room.amount = checkoutItem.amount;
            }
        })
    },
    setCustomSelection(state, isSelected: boolean) {
        state.hasCustomSelection = isSelected;
    }
} as MutationTree<RoomState>
